import { ExamMode } from "@app/constants";
import HttpService from "./http.service";
import { Exam } from "@app/models/exam.model";

class _ExamService {
  public create(testId: number, name: string) {
    return HttpService.post<Exam>("/exams", {
      body: {
        testId,
        name,
        mode: ExamMode.PRACTICE,
      },
    });
  }
}

const ExamService = new _ExamService();

export default ExamService;
